// John Eldhose 20210616
import React, { Component } from 'react';
import { Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { Fullscreen, FullscreenExit, Pause, PlayArrow, Settings, SlowMotionVideo, VolumeDown, VolumeMute, VolumeOff, VolumeUp } from '@material-ui/icons';

class Video extends Component {

  constructor(props) {
    super(props);
    this.videoContRef = React.createRef();
    this.videoRef = React.createRef();
  }
  visibleTimeout = 5;
  state = {
    setting: null,
    visible: this.visibleTimeout,
    stat: {
      currentTime: 0,
      duration: 0,
      fullscreenElement: false,
      muted: false,
      paused: false,
      playbackRate: 1,
      volume: 1
    }
  }
  update = () => {
    if(this.videoRef.current !== null) {
      const stat = JSON.parse(JSON.stringify(this.state.stat));
      const vdo = this.videoRef.current;
      const keys = Object.keys(stat);
      var updated = false; var visible = this.state.visible;
      for(var i = 0; i < keys.length; i++)
        if(keys[i] === 'fullscreenElement') {
          if(stat[keys[i]] !== (document[keys[i]] !== null)) {
            stat[keys[i]] = !stat[keys[i]];
            updated = true;
            visible = this.visibleTimeout;
          }
        }
        else if(!isNaN(vdo[keys[i]]) && stat[keys[i]] !== vdo[keys[i]]) {
          stat[keys[i]] = vdo[keys[i]];
          updated = true;
          if(keys[i] !== 'currentTime')
            visible = this.visibleTimeout;
        }
      if(stat.paused === true && visible < this.visibleTimeout)
        visible = this.visibleTimeout;
      else if(stat.paused === false && visible > 0)
        visible--;
      if(updated)
        this.setState({ visible: visible, stat: stat });
      else if(visible !== this.state.visible)
        this.setState({ visible: visible });
    }
    setTimeout(this.update, 1000);
  }
  componentDidMount() {
    this.update();
    this.videoRef.current.focus();
  }
  control = (key, val) => {
    if(this.videoRef.current !== null) {
      const stat = JSON.parse(JSON.stringify(this.state.stat));
      const vdo = this.videoRef.current;
      switch(key) {
        case 'fs':
          stat.fullscreenElement = val;
          this.setState({ stat: stat });
          if(val)
            this.videoContRef.current.requestFullscreen();
          else
            document.exitFullscreen();
          break;
        case 'seek':
          stat.currentTime = parseFloat(val);
          this.setState({ stat: stat });
          vdo.currentTime = val;
          break;
        case 'mute':
          stat.muted = val;
          this.setState({ stat: stat });
          vdo.muted = val;
          break;
        case 'pause':
          stat.paused = val;
          this.setState({ stat: stat });
          val ? vdo.pause() : vdo.play();
          break;
        case 'sett':
          this.setState({ setting: (
            (val === null || this.state.setting !== null) ? null : val
          ) });
          break;
        case 'speed':
          stat.playbackRate = val;
          this.setState({ stat: stat });
          vdo.playbackRate = val;
          break;
        case 'vol':
          stat.volume = val;
          this.setState({ stat: stat });
          vdo.volume = val;
          break;
        default:
          break;
      }
    }
  }
  seekIncrement = 5;
  controlKey = (stat, e) => {
    if(typeof e.key === 'string')
      switch(e.key) {
        case ' ':
          e.preventDefault();
          this.control('pause', !stat.paused);
          break;
        case 'ArrowLeft':
          if(stat.currentTime > this.seekIncrement) {
            this.setState({ visible: this.visibleTimeout });
            this.control('seek', (stat.currentTime - this.seekIncrement));
          }
          break;
        case 'ArrowRight':
          if((stat.duration - stat.currentTime) > this.seekIncrement) {
            this.setState({ visible: this.visibleTimeout });
            this.control('seek', (stat.currentTime + this.seekIncrement));
          }
          break;
        case 'f':
        case 'F':
          this.setState({ visible: this.visibleTimeout });
          this.control('fs', !stat.fullscreenElement);
          break;
        default:
          break;
      }
  }
  settingMenu = (stat) => {
    if(this.state.setting === null || this.state.visible < 1)
      return '';
    else
      return (
        <div className='videoSetting'>
          <List>
            <ListItem>
              <ListItemIcon>
                <SlowMotionVideo style={{ color: '#fff' }} />
              </ListItemIcon>
              <ListItemText primary={
                <span style={{ color: '#fff' }}>Playback Speed</span>
              } />
              <ListItemText primary={
                <select
                  value={stat.playbackRate}
                  style={{ background: '#000', color: '#fff' }}
                  onChange={(e) => this.control('speed', e.target.value)}
                >
                {[.25, .5, .75, 1, 1.25, 1.5, 1.75, 2].map((s) => (
                  <Typography
                    color='inherit' component='option' value={s} key={s}
                    style={{ padding: '20px 5px' }}
                  >
                    {(s === 1) ? 'Normal' : s}
                  </Typography>
                ))}
                </select>
              } />
            </ListItem>
          </List>
        </div>
      );
  }
  showTime = (msec) => {
    var sec = msec.toFixed(0); var rm = 0; var rs = 0;
    if(sec > 0) {
      rm = Math.floor(sec / 60);
      rs = (sec - (rm * 60)).toFixed(0);
    }
    return (rm + ':' + ((rs < 10) ? 0 : '') + rs);
  }
  volumeIcon = (m, v) => {
    if(m === true)
      return <VolumeOff style={{ transform: 'scale(.9)' }} />;
    else if(v < .3)
      return <VolumeMute style={{ transform: 'scale(.9)' }} />;
    else if(v < .6)
      return <VolumeDown style={{ transform: 'scale(.9)' }} />;
    else
      return <VolumeUp style={{ transform: 'scale(.9)' }} />;
  }

  render() {
    const stat = this.state.stat;
    return (
      <div className='videoContainer'
        ref={this.videoContRef}
        onMouseMove={() => this.setState({ visible: this.visibleTimeout })}
        onKeyDown={(e) => this.controlKey(stat, e)}
        onLoad={(e) => console.log(e)}
      >
        <video
          width='100%'
          height='100%'
          controls={false}
          preload='auto'
          onEnded={this.props.ended}
          autoPlay={true}
          ref={this.videoRef}
          onClick={() => this.control('pause', !stat.paused)}
        >
          <source src={this.props.src} />
          Your browser does not support html5 video
        </video>
        {this.settingMenu(stat)}
        <div className='videoControls'
          style={{visibility: ((this.state.visible > 0) ? true : 'hidden') }}
        >
          <Grid container
            direction='row'
            justify='space-between'
            alignItems='center'
          >
            <Grid item xs={12} style={{ padding: '0 12px 0 10px' }}>
              <input
                type='range'
                className='videoProgress'
                min={0}
                max={stat.duration}
                step={1}
                value={stat.currentTime}
                onChange={(e) => this.control('seek', e.target.value)}
              />
            </Grid>
            <Grid item xs={6} align='left' style={{ padding: '0 0 0 15px'}} >
              <a className='videoButton' onClick={
                () => this.control('pause', !stat.paused)
              }>
                { stat.paused ? <PlayArrow /> : <Pause /> }
              </a>
              <Typography
                variant='caption'
                color='inherit'
                gutterBottom={true}
                noWrap={true}
                style={{ display: 'inline-block' }}
              > {
                this.showTime(stat.currentTime) + ' / ' +
                this.showTime(stat.duration)
              }
              </Typography>
            </Grid>
            <Grid item xs={6} align='right' style={{padding: '0 15px 0 0'}}>
              <a className='videoButton'
                aria-owns={(stat.setting === null) ? null : 'simple-menu'}
                aria-haspopup='true'
                onClick={(e) => this.control('sett', e.currentTarget)}
              >
                <Settings style={{ transform: 'scale(.8)' }} />
              </a>
              <a className='videoButton' onClick={
                () => this.control('mute', !stat.muted)
              }>
                { this.volumeIcon(stat.muted, stat.volume) }
              </a>
              <input
                type='range'
                className='videoVolume'
                min={0}
                max={1}
                step={.1}
                value={stat.volume}
                onChange={(e) => this.control('vol', e.target.value)}
              />
              <a className='videoButton' onClick={
                () => this.control('fs', !stat.fullscreenElement)
              }> {
                stat.fullscreenElement ? <FullscreenExit /> : <Fullscreen />
              }
              </a>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/lib/Video.js